import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { Box, Text } from 'grommet';
import { useAppTheme } from '@Components/Context';
import { Spinning } from '../Loaders';

const EmbeddedVideoPlayer = ({ url, fileName = null, maxHeight = '500px' }) => {
  const [cannotPlay, setCannotPlay] = React.useState(false);
  const { theme: { page } } = useAppTheme();

  if (!url) return null;

  if (cannotPlay) {
    return (
      <Box
        align="center"
        justify="center"
        pad="2rem"
        background="#000"
        round="small"
        gap="0.75rem"
      >
        <Text color="#ccc" size="0.85rem" textAlign="center">
          This video format cannot be played in your browser.
        </Text>
        <Text
          as="a"
          href={url}
          download={fileName || true}
          target="_blank"
          rel="noopener noreferrer"
          size="0.85rem"
          color="var(--page-url-color)"
        >
          {fileName ? `Download ${fileName}` : 'Download video file'}
        </Text>
      </Box>
    );
  }

  return (
    <Box
      style={{
        width: '100%',
        aspectRatio: '16 / 9',
        maxHeight,
        background: '#000',
        overflow: 'hidden',
      }}
    >
      <ReactPlayer
        src={url}
        controls
        playsinline
        width="100%"
        height="100%"
        onError={() => setCannotPlay(true)}
        config={{
          file: {
            attributes: { controlsList: 'nodownload' },
          },
        }}
        fallback={<Spinning size="large" color={page.highlight} />}
      />
    </Box>
  );
};

EmbeddedVideoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  fileName: PropTypes.string,
  maxHeight: PropTypes.string,
};

export default EmbeddedVideoPlayer;
